import React, { useState, useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Formik, Form } from 'formik'
import { toast } from 'react-toastify'
import locationApi from '../../utils/locationApi'

import config from '../../config'
import { Button, Modal, InputGroup, FormControl, Spinner } from 'react-bootstrap'

const urlVehicle = config.api.baseUrl + '/vehicles'
const urlBranch = config.api.baseUrl + '/branches'

const EditVehicleModal = (props) => {
  const { data, onClose } = props

  const [branches, setBranches] = useState()
  const [loading, setLoading] = useState(true)
  const [confirmDelete, setConfirmDelete] = useState(false)

  useEffect(() => {
    (async () => {
      try {
        const res = await locationApi('get', urlBranch)
        setLoading(false)
        setBranches(res.data)
      } catch (err) {
        setLoading(false)
        console.log(err)
      }
    })()
  }, [data.pmId])

  const handleSubmit = useCallback(
    async (data) => {
      try {
        await locationApi('post', urlVehicle, data)
        onClose()
        toast('Succesfully updated.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2500
        })
      } catch (err) {
        onClose()
        toast.error(`${err}`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2500
        })
        console.log(err)
      }
    }, [onClose])

  const handleDelete = useCallback(
    async (event) => {
      event.preventDefault()
      const newUrl = urlVehicle + `/${data.pmId}`

      if (confirmDelete) {
        try {
          await locationApi('delete', newUrl)
          onClose()
          toast('Succesfully Deleted.', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2500
          })
        } catch (err) {
          onClose()
          toast.error(`Error: ${err}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2500
          })
          console.log(err)
        }
      } else {
        setConfirmDelete(true)
      }
    }, [confirmDelete, onClose, data.pmId])

  return (
    <>
      <Formik
        initialValues={{
          pmId: data.pmId,
          reg: data.reg,
          branches: data.branches,
          cseId: data.cseId,
          pipelineId: data.pipelineId,
          acetrackId: data.acetrackId
        }}
        onSubmit={handleSubmit}
      >{
          ({ values, handleChange, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Modal show onHide={onClose}>
                <Modal.Header closeButton>
                  <Modal.Title>{values.pmId.toUpperCase()}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {loading
                    ? <Spinner animation='border' />
                    : (
                      <>
                        <InputGroup className='mb-3'>
                          <InputGroup.Prepend>
                            <InputGroup.Text>Registration No.</InputGroup.Text>
                          </InputGroup.Prepend>
                          <FormControl
                            name='reg'
                            value={values.reg}
                            onChange={handleChange}
                          />
                        </InputGroup>

                        <InputGroup className='mb-3'>
                          <InputGroup.Prepend>
                            <InputGroup.Text>Branch</InputGroup.Text>
                          </InputGroup.Prepend>
                          <FormControl as='select' multiple custom value={values?.branches || []} name='branches' onChange={handleChange}>
                            {
                              branches?.map(branch => {
                                return (<option key={branch.name} value={branch.name}>{branch.name}</option>)
                              })
                            }
                          </FormControl>
                        </InputGroup>
                        <InputGroup className='mb-3'>
                          <InputGroup.Prepend>
                            <InputGroup.Text>CSE ID</InputGroup.Text>
                          </InputGroup.Prepend>
                          <FormControl
                            name='cseId'
                            value={values.cseId}
                            onChange={handleChange}
                          />
                        </InputGroup>
                        <InputGroup className='mb-3'>
                          <InputGroup.Prepend>
                            <InputGroup.Text>Pipe Line ID</InputGroup.Text>
                          </InputGroup.Prepend>
                          <FormControl
                            name='pipelineId'
                            value={values.pipelineId}
                            onChange={handleChange}
                          />
                        </InputGroup>
                        <InputGroup className='mb-3'>
                          <InputGroup.Prepend>
                            <InputGroup.Text>Acetrack ID</InputGroup.Text>
                          </InputGroup.Prepend>
                          <FormControl
                            name='acetrackId'
                            value={values.acetrackId}
                            onChange={handleChange}
                          />
                        </InputGroup>
                      </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                  {!confirmDelete
                    ? (
                      <Button variant='danger' onClick={handleDelete}>
                        Delete
                      </Button>
                    )
                    : (
                      <Button variant='danger' onClick={handleDelete}>
                        Click Again to Delete
                      </Button>
                    )}
                  <Button onClick={handleSubmit}>
                    Save Changes
                  </Button>
                </Modal.Footer>
              </Modal>
            </Form>
          )
        }
      </Formik>}
    </>
  )
}

export default EditVehicleModal

EditVehicleModal.propTypes = {
  data: PropTypes.object,
  onClose: PropTypes.func
}
